/**
 * @ngdoc module
 * @name flowingly.directives.sidemenu
 * @module flowingly.directives.sidemenu
 * @requires flowingly.user.menu
 * @description Sidemenu components (React)
 * See Also: https://bizflo.atlassian.net/wiki/display/TECH/Sidemenu+Directive
 */
import angular from 'angular';
import { sidemenuBridge } from './SidemenuBridge';

const sidemenuModule = angular.module('flowingly.directives.sidemenu', [
  'flowingly.user.menu'
]);

sidemenuModule.component('flowSidemenu', sidemenuBridge);
